import { render, staticRenderFns } from "./DiagnosticPickerForProduct.vue?vue&type=template&id=17bcaa58"
import script from "./DiagnosticPickerForProduct.vue?vue&type=script&lang=ts"
export * from "./DiagnosticPickerForProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports